import { Component, inject } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast-host',
  imports: [TegelModule],
  templateUrl: './toast-host.html',
  styleUrl: './toast-host.scss',
})
export class ToastHost {
  private readonly toastService = inject(ToastService);

  readonly toast = this.toastService.toast;

  close(): void {
    this.toastService.clear();
  }
}
